import { dispatcherGuards } from '@/components/management/dispatcher/access';

/**
 * Route record for /management/dispatcher (KOP-31 spec §5.3; catalog child per KOP-37, tracker per KOP-38, expenses per KOP-39).
 */
export function buildDispatcherRoute({ shell, map, tracker, catalog, expenses, guards = dispatcherGuards }) {
  return {
    path: '/management/dispatcher',
    component: shell,
    beforeEnter: guards.parent,
    children: [
      { path: '', name: 'dispatcher-index', redirect: () => guards.indexRedirect() },
      { path: 'map', name: 'dispatcher-map', beforeEnter: guards.section('map'), component: map },
      { path: 'tracker', name: 'dispatcher-tracker', beforeEnter: guards.section('tracker'), component: tracker },
      { path: 'catalog', name: 'dispatcher-catalog', beforeEnter: guards.section('catalog'), component: catalog },
      { path: 'expenses', name: 'dispatcher-expenses', beforeEnter: guards.section('expenses'), component: expenses },
    ],
  };
}

export default buildDispatcherRoute({
  shell: () => import('@/views/pages/management/dispatcher/index.vue'),
  map: () => import('@/views/pages/management/dispatcher/MapSection.vue'),
  tracker: () => import('@/views/pages/management/dispatcher/TrackerSection.vue'),
  catalog: () => import('@/views/pages/management/dispatcher/CatalogSection.vue'),
  expenses: () => import('@/views/pages/management/dispatcher/ExpensesSection.vue'),
});
